<div class="it">
  <div class="it__toolbar">
    <app-search-input label="Search rows"
      class="it__search"
      placeholder="Search name, phone or email"
      [debounce]="200"
      (valueChange)="updateSearchTerm($event)"
    />
    <app-status-filter
      label="Show"
      [options]="filterOptions"
      [selectedValue]="filterTitle"
      allLabel="All rows"
      (selectionChange)="updateFilterOption($any($event))"
    />
  </div>

  <p class="bk-sr-only" role="status">{{ selectedIndexes.length ? selectionLabel : '' }}</p>
  @if (selectedIndexes.length) {
    <div class="it-select" role="region" aria-label="Selected rows">
      <span class="it-select__count">{{ selectionLabel }}</span>
      <span class="it-select__actions">
        <button type="button" class="it-select__btn" (click)="handleAction('assign-organization')">
          <span class="bk-sym" aria-hidden="true">domain_add</span>
          Add to organization
        </button>
        <button type="button" class="it-select__btn" (click)="handleAction('assign-tags')">
          <span class="bk-sym" aria-hidden="true">sell</span>
          Add tags
        </button>
        <button type="button" class="it-select__btn is-danger" (click)="handleAction('delete')">
          <span class="bk-sym" aria-hidden="true">delete</span>
          Remove from import
        </button>
      </span>
      <button type="button" class="it-select__btn it-select__clear" (click)="resetSelectedContactIndexes()">
        Clear selection
      </button>
    </div>
  }

  <div class="bk-panel it__panel">
    <!-- Phones hide the header row, so its select-all moves here. -->
    @if (pagedContacts.length) {
      <label class="it__selectall">
        <input
          type="checkbox"
          class="it__check"
          [checked]="getIsAllSelected"
          [indeterminate]="someSelected"
          (change)="toggleSelectAllIndexes()"
        />
        Select every row in this list
      </label>
    }
    <data-table label="Contacts to import" [seamless]="true" [maxHeight]="'640px'" [skeletonColumns]="7" [resizable]="false">
      @if (pagedContacts.length) {
        <table class="bk-log">
          <thead>
            <tr>
              <th scope="col" class="col-check">
                <input
                  type="checkbox"
                  class="it__check"
                  [checked]="getIsAllSelected"
                  [indeterminate]="someSelected"
                  (change)="toggleSelectAllIndexes()"
                  aria-label="Select every row in this list"
                />
              </th>
              <th scope="col" class="num col-row">Row</th>
              <th scope="col" class="col-name">Contact</th>
              <th scope="col" class="col-phone">Phone</th>
              <th scope="col" class="col-groups">Organizations</th>
              <th scope="col" class="col-groups">Tags</th>
              <th scope="col" class="col-issue">Check</th>
              <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
            </tr>
          </thead>
          <tbody>
            @for (contact of pagedContacts; track rowKey(contact, $index)) {
              <tr
                class="is-link"
                tabindex="0"
                [class.is-selected]="getIndexIsSelected(contact.personEntity.id!)"
                (click)="openContactDetail(contact, contact.personEntity.id!)"
                (keydown.enter)="openFromKeyboard($event, contact)"
              >
                <td class="col-check" (click)="$event.stopPropagation()">
                  <input
                    type="checkbox"
                    class="it__check"
                    [checked]="getIndexIsSelected(contact.personEntity.id!)"
                    (change)="selectIndex(contact.personEntity.id!)"
                    [attr.aria-label]="'Select ' + name(contact)"
                  />
                </td>
                <td class="num quiet col-row">{{ rowNumber(contact) ?? '—' }}</td>
                <td class="col-name">
                  <span class="bk-msg">
                    <span class="bk-msg__subject">{{ name(contact) }}</span>
                    <span class="bk-msg__preview">{{ contact.personEntity.emailAddress || 'No email' }}</span>
                  </span>
                </td>
                <td class="quiet col-phone">{{ contact.personEntity.primaryContactNumber || '—' }}</td>
                <!-- "Acme +2" on screen; the full list is in the title and read out in full. -->
                <td
                  class="quiet col-groups"
                  [attr.title]="groupTitle(contact.personEntity.companyEntities)"
                >
                  @if (groupTitle(contact.personEntity.companyEntities); as all) {
                    <span aria-hidden="true">{{ groupNames(contact.personEntity.companyEntities) }}</span>
                    <span class="bk-sr-only">{{ all }}</span>
                  } @else {
                    {{ groupNames(contact.personEntity.companyEntities) }}
                  }
                </td>
                <td class="quiet col-groups" [attr.title]="groupTitle(contact.personEntity.entityTags)">
                  @if (groupTitle(contact.personEntity.entityTags); as all) {
                    <span aria-hidden="true">{{ groupNames(contact.personEntity.entityTags) }}</span>
                    <span class="bk-sr-only">{{ all }}</span>
                  } @else {
                    {{ groupNames(contact.personEntity.entityTags) }}
                  }
                </td>
                <td class="col-issue">
                  @if (contact.batchLineValidationStatus === 'PROCESSING_ERROR') {
                    <ul class="it__issues">
                      @for (issue of issues(contact); track $index) {
                        <li>
                          @if ($first) {
                            <app-status [text]="issueText(issue)" status="failed" />
                          } @else {
                            <span class="it__issue-more">{{ issueText(issue) }}</span>
                          }
                        </li>
                      } @empty {
                        <li><app-status text="Will not import" status="failed" /></li>
                      }
                    </ul>
                  } @else {
                    <app-status text="Ready" status="success" />
                  }
                </td>
                <td class="col-actions">
                  <span class="bk-row-actions">
                    <button
                      type="button"
                      class="bk-icon-btn"
                      [attr.aria-label]="'Edit ' + name(contact)"
                      matTooltip="Edit row"
                      (click)="$event.stopPropagation(); openEditContact(contact, contact.personEntity.id!)"
                    >
                      <span class="bk-sym" aria-hidden="true">edit</span>
                    </button>
                    <button
                      type="button"
                      class="bk-icon-btn it__danger"
                      [attr.aria-label]="'Remove ' + name(contact) + ' from this import'"
                      matTooltip="Remove row"
                      (click)="$event.stopPropagation(); openDeletePrompt(contact, contact.personEntity.id!)"
                    >
                      <span class="bk-sym" aria-hidden="true">delete</span>
                    </button>
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <app-empty-state
          icon="contacts"
          message="No rows left in this import"
          [query]="searchTerm"
          [filtered]="filterTitle !== 'All'"
          size="medium"
          (clear)="clearSearchAndFilter()"
        />
      }
    </data-table>
  </div>

  @if (getFilteredContacts.length > pageSize) {
    <div class="it__pager">
      <app-pagination
        [totalPages]="totalPages"
        [currentPage]="currentPage"
        [totalItems]="getFilteredContacts.length"
        [pageSize]="pageSize"
        (changePage)="goToPage($event)"
        (onNext)="nextPage()"
        (onPrev)="prevPage()"
        (pageSizeChange)="changePageSize($event)"
      />
    </div>
  }

  <!-- MODALS -->
  @if (showContactDetail) {
    <contact-detail
      (closeModal)="closeContactDetail()"
      [contact]="selectedContact?.personEntity ?? null"
      [isLocalContacts]="true"
    />
  }

  @if (openEditContactModal) {
    <edit-uploaded-contact
      [index]="selectedContactIndex!"
      [selectedContact]="selectedContact?.personEntity ?? null"
      [issues]="selectedContact?.constraintViolations ?? []"
      (closeModalEvent)="closeEditContact()"
    />
  }

  <app-prompt-card
    buttonText="Remove row"
    title="Remove this row?"
    tone="danger"
    [openModal]="showDeletePrompt"
    (onClose)="closeDeletePrompt()"
    (onButtonClick)="deleteContact()"
  >
    <p class="it__prompt">
      <strong>{{ name(selectedContact) }}</strong> will be left out of this import. Your file is not changed.
    </p>
  </app-prompt-card>

  <app-prompt-card
    [buttonText]="selectedIndexes.length === 1 ? 'Remove row' : 'Remove ' + selectedIndexes.length + ' rows'"
    title="Remove the selected rows?"
    tone="danger"
    [openModal]="showDeleteSelectedPrompt"
    (onClose)="closeDeleteSelectedPrompt()"
    (onButtonClick)="confirmDeleteSelected()"
  >
    <p class="it__prompt">They will be left out of this import. Your file is not changed.</p>
  </app-prompt-card>

  <csv-assign-multiple-contacts-to-organizations
    [open]="showAssignMultipleOrganizationsModal"
    (close)="closeAssignMultipleOrganizationsModal()"
    [selectedContactsIndexes]="selectedIndexes"
    (resetSelectedContactsIndexes)="resetSelectedContactIndexes()"
  />
  <csv-assign-multiple-contacts-to-tags
    [open]="showAssignMultipleTagsModal"
    (close)="closeAssignMultipleTagsModal()"
    [selectedContactsIndexes]="selectedIndexes"
    (resetSelectedContactsIndexes)="resetSelectedContactIndexes()"
  />
</div>
